import { render, staticRenderFns } from "./DocumentListView.vue?vue&type=template&id=1ad86cd8&scoped=true&"
import script from "./DocumentListView.vue?vue&type=script&lang=ts&"
export * from "./DocumentListView.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentListView.vue?vue&type=style&index=0&id=1ad86cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad86cd8",
  null
  
)

export default component.exports